var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19081_910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9945 10.7838C22.6488 9.8665 21.763 9.25 20.791 9.25H20.5V8.5H19V9.25H13V8.5H11.5V9.25H11.209C10.2362 9.25 9.3505 9.8665 9.0055 10.7838C7.3405 15.2102 7 20.0913 7 21.1562C7 22.4485 8.0515 23.5 9.34375 23.5C11.3605 23.5 13.2767 19.9893 13.921 18.25H18.0798C18.7232 19.9893 20.6395 23.5 22.657 23.5C23.9492 23.5 25.0007 22.4485 25.0007 21.1562C25.0007 20.0913 24.6595 15.2102 22.9945 10.7838ZM12.625 15.25C12.004 15.25 11.5 14.746 11.5 14.125C11.5 13.504 12.004 13 12.625 13C13.246 13 13.75 13.504 13.75 14.125C13.75 14.746 13.246 15.25 12.625 15.25ZM19.375 15.25C18.754 15.25 18.25 14.746 18.25 14.125C18.25 13.504 18.754 13 19.375 13C19.996 13 20.5 13.504 20.5 14.125C20.5 14.746 19.996 15.25 19.375 15.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19081_910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaming);
export default __webpack_public_path__ + "static/media/gaming.9961b2a4e8da74feb5ad32f8bbbe7fa5.svg";
export { ForwardRef as ReactComponent };